import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  { path: "/login", component: () => import("../views/Login.vue") },
  // 移动端扫码页（无需登录，客户/工作人员扫码后按订单号查详情+确认收货/归还）
  {
    path: "/m/scan",
    component: () => import("../views/mobile/ScanReceive.vue"),
    meta: { public: true },
  },
  {
    path: "/m/device/:id",
    component: () => import("../views/mobile/DeviceDetail.vue"),
    meta: { public: true },
  },
  // 扫码出库表单（在库设备扫码后进入，公开访问）
  {
    path: "/m/device/:id/dispatch",
    component: () => import("../views/mobile/DeviceDispatch.vue"),
    meta: { public: true },
  },
  {
    path: "/",
    component: () => import("../views/Layout.vue"),
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        component: () => import("../views/Dashboard.vue"),
        meta: { title: "首页统计" },
      },
      {
        path: "product-add",
        component: () => import("../views/ProductAdd.vue"),
        meta: { title: "产品录入" },
      },
      {
        path: "product-list",
        component: () => import("../views/ProductList.vue"),
        meta: { title: "产品列表" },
      },
      {
        path: "accessory-add",
        component: () => import("../views/AccessoryAdd.vue"),
        meta: { title: "配件录入" },
      },
      {
        path: "accessory-list",
        component: () => import("../views/AccessoryList.vue"),
        meta: { title: "配件列表" },
      },
      {
        path: "rental-out",
        component: () => import("../views/RentalOut.vue"),
        meta: { title: "产品出库" },
      },
      {
        path: "rental-in",
        component: () => import("../views/RentalIn.vue"),
        meta: { title: "产品入库" },
      },
      {
        path: "out-list",
        component: () => import("../views/OutList.vue"),
        meta: { title: "出库列表" },
      },
      {
        path: "in-list",
        component: () => import("../views/InList.vue"),
        meta: { title: "入库列表" },
      },
      {
        path: "price-settings",
        component: () => import("../views/PriceSettings.vue"),
        meta: { title: "价格设置" },
      },
      {
        path: "user-settings",
        component: () => import("../views/UserSettings.vue"),
        meta: { title: "人员设置" },
      },
      {
        path: "print-settings",
        component: () => import("../views/PrintSettings.vue"),
        meta: { title: "打印设置", perm: "print_settings" },
      },
      {
        path: "hik-scan",
        component: () => import("../views/HikScan.vue"),
        meta: { title: "设备出库", perm: "hik_scan" },
      },
      {
        path: "order-manage",
        component: () => import("../views/OrderManage.vue"),
        meta: { title: "订单管理", perm: "order_manage" },
      },
      {
        path: "qr-settings",
        component: () => import("../views/QrSettings.vue"),
        meta: { title: "二维码设置", perm: "qr_settings" },
      },
      {
        path: "unboxing-record",
        component: () => import("../views/UnboxingRecord.vue"),
        meta: { title: "开箱录制", perm: "unboxing_record" },
      },
      {
        path: "unboxing-list",
        component: () => import("../views/UnboxingList.vue"),
        meta: { title: "开箱列表", perm: "unboxing_list" },
      },
      {
        path: "device-list",
        component: () => import("../views/DeviceList.vue"),
        meta: { title: "设备列表" },
      },
      {
        path: "device-add",
        component: () => import("../views/DeviceAdd.vue"),
        meta: { title: "设备添加" },
      },
      {
        path: "device-name-manage",
        component: () => import("../views/DeviceNameManage.vue"),
        meta: { title: "名称管理" },
      },
      {
        path: "device-schedule",
        component: () => import("../views/DeviceSchedule.vue"),
        meta: { title: "设备排期表" },
      },
    ],
  },
];

const router = new VueRouter({ mode: "history", routes });

// 导航守卫：未登录强制跳登录页
// 公开路径硬编码放行（移动端扫码等）+ meta.public 双保险
// 用 cleanPath 容错：去掉可能混入的 ?query #hash 后再匹配
// （Vue Router 3 在某些场景下 to.path 可能含 query 字符串）
const PUBLIC_PATHS = ["/m/scan"];

router.beforeEach((to, from, next) => {
  const cleanPath = (to.path || "").split("?")[0].split("#")[0];

  // 兜底 1：新格式二维码在任意路径下带 ?device=ID（例：/m/scan/?device=5）
  // → 客户端跳转设备详情页。即便 base_url 配错（如设成 /m/scan）也能救回来。
  if (to.query && to.query.device) {
    return next("/m/device/" + to.query.device);
  }

  // 兜底 2：兼容早期错误拼接的设备二维码路径 /m/scan/m/device/:id
  // （base_url 被误设为 /m/scan + 旧格式 /m/device/<id> 拼出来）。
  // 把这种已打印的旧码也救回来，避免物理标签作废。
  var legacyDevice = cleanPath.match(/^\/m\/scan\/m\/device\/(\d+)\/?$/);
  if (legacyDevice) {
    return next("/m/device/" + legacyDevice[1]);
  }

  if (PUBLIC_PATHS.indexOf(cleanPath) >= 0 || (to.meta && to.meta.public)) {
    return next();
  }
  const token = localStorage.getItem("token");
  if (to.path === "/login") {
    return token ? next("/dashboard") : next();
  }
  if (!token) {
    return next("/login");
  }
  // 工作人员权限校验：管理员放行；未配置权限的旧账号默认全部放行；否则按权限数组判定
  if (to.meta && to.meta.perm) {
    var role = localStorage.getItem("role") || "staff";
    var perms = [];
    try {
      var u = JSON.parse(localStorage.getItem("user") || "{}");
      perms = JSON.parse(u.permissions || "[]");
    } catch (e) { perms = []; }
    var allowed = role === "admin" || !perms.length || perms.indexOf(to.meta.perm) >= 0;
    if (!allowed) return next("/dashboard");
  }
  next();
});

export default router;
